import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { RemoveVersionPipe } from '../remove-version.pipe';

export interface Section {
  links: Array<SectionData>;
  footer: string;
  description: string;
  title: string;
}

export interface SectionData {
  link: string;
  description: string;
  title: string;
  image: string;
  modal?: any;
  imageHover: string;
  hasHover: boolean;
}

@Component({
  selector: 'fcp-section-icon',
  templateUrl: './section-icon.component.html',
  styleUrls: ['./section-icon.component.scss'],
})
export class SectionIconComponent implements OnInit {
  @Input() public section: Section;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();

  constructor(private removeVersion: RemoveVersionPipe) {}

  public ngOnInit(): void {}

  public setImage(elem: HTMLDivElement, url): void {
    if (elem) {
      elem['src'] = this.removeVersionImage(url);
    }
  }

  private removeVersionImage(value: string): string {
    return this.removeVersion.transform(value);
  }

  public emitClick(section: SectionData): void {
    this.wasClicked.emit(section);
  }
}
